//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import {search,list,modelfields} from '@/base/js/api'   
    export default {
        name: 'app',
        data() {
            return {
               useClassify:'',
               productName:'',
               history:[]   
            }
        },
        components: {
            
        },
        beforeRouteLeave(to, from, next) {
            // 设置下一个路由的 meta
            to.meta.keepAlive = false; //  使产品不缓存，即刷新
            next();
        },
        created(){
              console.log(localStorage.getItem('history'))
            if(localStorage.getItem('history')){
              this.history = JSON.parse(localStorage.getItem('history'))
            }
        },
        methods: {
           okBtn(e){
               let historyTmp = []
               console.log(this.history)
               if(this.productName){
                   this.history.push(this.productName) 
               }
               let historyTmps =JSON.stringify(this.history)
               localStorage.setItem('history',historyTmps)
               console.log(e)
               if(e){
                 this.$router.push({path: '/product', query: {productName:e}})  
                 return   
               }
               this.$router.push({path: '/product', query: {productName:this.productName}})
           },
           shanchu(){
              localStorage.removeItem('history')
               this.history =[]
           },
           remen(e){
               this.$router.push({path: '/product', query: {categoryId:e}})
           }
        }
    }



// WEBPACK FOOTER //
// ./src/pages/search/search.vue